import { ExamDateDto, Gender } from "api";
import { createContext, Dispatch, SetStateAction, useContext } from "react";
import { Maybe } from "yup";

export type RegistrationJourneyState = {
  createdOn: Date;
  stepIndex: number;
  selectedExam?: ExamDateDto;
  loadedFromStorage?: boolean;
  termsAccepts?: {
    termsAccepted: boolean;
    termsPhotoAccepted: boolean;
  };
  marketingConsent?: boolean;
  candidateDetails?: {
    firstName: string;
    middleName?: string;
    lastName: string;
    gender: Gender;
    dateOfBirth: string;
    emailAddress: string;
    confirmEmailAddress: string;
    phoneNumber: string;
    guardian?: string;
    address: {
      street: string;
      postalCode: string;
      city: string;
    };
    permissionToLeave?: {
      canLeave?: Maybe<boolean>;
      guardianName?: Maybe<string>;
      guardianPhone?: Maybe<string>;
      personCollectingCandidate?: Maybe<string>;
    };
    specialRequirements?: {
      disability?: Maybe<boolean>;
      dyslexia?: Maybe<boolean>;
      description?: string;
      files?: File[];
    };
  };
};

export const DEFAULT_JOURNEY_STATE: RegistrationJourneyState = {
  createdOn: new Date(),
  stepIndex: 0,
  selectedExam: undefined,
  termsAccepts: undefined,
  candidateDetails: undefined,
  marketingConsent: undefined,
};

export type RegistrationJourneyContextType = {
  journey: RegistrationJourneyState;
  setJourney: Dispatch<SetStateAction<RegistrationJourneyState>>;
};

export const RegistrationJourneyContext = createContext<
  RegistrationJourneyContextType | undefined
>(undefined);

export const useRegistrationJourneyContext = () => {
  const context = useContext(RegistrationJourneyContext);

  if (context === undefined) {
    throw new Error(
      "useRegistrationJourneyContext must be used within a RegistrationJourneyContext"
    );
  }

  return context;
};
